<template>
  <div class="border border-dark p-2 mb-2">
    <BaseTextFieldGroupWithProvider
      v-model="_value.name"
      empty-str-to-null
      :label="`項目名 - ${_value.displayOrder + 1}`"
      placeholder="空白にするとメンバーが自由に項目名を設定できます" />
    <slot />
  </div>
</template>

<script>

import BaseTextFieldGroupWithProvider from '@/components/parts/BaseTextFieldGroupWithProvider.vue'
export default {
  components: {
    BaseTextFieldGroupWithProvider,
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        return this.$emit('input', v)
      }
    }
  }
}
</script>

<style>

</style>